import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Nav, Footer } from './shared';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function Layout() {
  return (
    <div style={{ fontFamily: "var(--body)", color: "#0e1219", background: "#fafbfd" }}>
      <ScrollToTop />
      <Nav />
      <Outlet />
      <Footer />
    </div>
  );
}
